export default __webpack_public_path__ + "static/media/ayfi.2f3b6624.svg";